
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { InAppNotificationClient } from '@/services/Services';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class monthlyCommissionsPaid extends Vue {

    @Prop() item: OM.MonthlyCommissionsPaid;

    onClick(){
        this.$router.push('/network/walletTransactions')
        .then(x => {
            this.$emit('clicked');
        });
    }

}
